import request from "@/config/utils/request";

// 公用 请求OMC组织机构下的部门及人员（不包含子集单位及其人员）
export function getUnderOrg(obj) {
  return request({
    url: "/apis/demo/org/listUnderOrg",
    method: "post",
    data: obj
  });
}
